//PCナビのホバーメニュー
document.addEventListener("DOMContentLoaded", function () {
  const menuItems = document.querySelectorAll(".js-menu-item");

  menuItems.forEach(function (menuItem) {
    menuItem.addEventListener("mouseover", function () {
      // hover
      const sublistWrap = menuItem.querySelector(".js-sublist-wrap");
      if (sublistWrap) {
        sublistWrap.classList.add("is-visible"); // CSSで表示スタイルを制御
      }
    });

    menuItem.addEventListener("mouseout", function () {
      // leave
      const sublistWrap = menuItem.querySelector(".js-sublist-wrap");
      if (sublistWrap) {
        sublistWrap.classList.remove("is-visible"); // CSSで非表示スタイルを制御
      }
    });
  });
});

// SPヘッダーのナビメニュー

document.addEventListener("DOMContentLoaded", function () {
  const hamburger = document.querySelector(".js-hamburger");
  const nav = document.querySelector(".js-nav");
  const body = document.body; // body要素を取得

  hamburger.addEventListener("click", function () {
    // トグルでクラスの付け外し
    hamburger.classList.toggle("is-open");
    nav.classList.toggle("is-open");
    body.classList.toggle("is-locked"); // スクロール制御用のクラスを付与/削除

    // ARIA属性の更新
    const expanded = hamburger.getAttribute("aria-expanded") === "true" || false;
    hamburger.setAttribute("aria-expanded", !expanded);
  });
});

//SPメニューの中のアコーディオン
document.addEventListener("DOMContentLoaded", function () {
  // 各アコーディオンメニューごとに処理
  document.querySelectorAll(".js-accordionMenu").forEach((accordionMenu) => {
    const accordionButtons = accordionMenu.querySelectorAll(".js-accordionMenuHeader");

    accordionButtons.forEach((button) => {
      button.addEventListener("click", function () {
        // ボタンに is-active クラスをトグル
        button.classList.toggle("is-active");

        // 対応するサブリストラップを取得
        const sublistWrap = button.closest(".l-headerSpNav__item--menu").querySelector(".js-accordionMenuContent");

        // サブリストラップに is-active クラスをトグル
        if (sublistWrap) {
          sublistWrap.classList.toggle("is-active");
        }

        // 同じアコーディオンメニュー内の他の項目を閉じる
        accordionButtons.forEach((otherButton) => {
          if (otherButton !== button) {
            otherButton.classList.remove("is-active");
            const otherSublistWrap = otherButton
              .closest(".l-headerSpNav__item--menu")
              .querySelector(".js-accordionMenuContent");
            if (otherSublistWrap) {
              otherSublistWrap.classList.remove("is-active");
            }
          }
        });
      });
    });
  });
});

